import { Subject } from '~/tutor-on-demand/types/tutor-on-demand.types'
import ROUTES from '~/shared/constants/routes.const'

export const menuItems = [
  {
    type: Subject.MATH,
    href: ROUTES.TUTOR_ON_DEMAND_MATH,
    iconSrc: 'mentor-on-demand/icons/math-black-light.svg',
  },
  {
    type: Subject.CHEMISTRY,
    href: ROUTES.TUTOR_ON_DEMAND_CHEMISTRY,
    iconSrc: 'mentor-on-demand/icons/chemistry-black-light.svg',
  },
  {
    type: Subject.ECONOMY,
    href: ROUTES.TUTOR_ON_DEMAND_ECONOMY,
    iconSrc: 'mentor-on-demand/icons/economy-black-light.svg',
  },
  {
    type: Subject.FINANCE,
    href: ROUTES.TUTOR_ON_DEMAND_FINANCE,
    iconSrc: 'mentor-on-demand/icons/finance-black-light.svg',
  },
  {
    type: Subject.STATISTICS,
    href: ROUTES.TUTOR_ON_DEMAND_STATISTICS,
    iconSrc: 'mentor-on-demand/icons/statistics-black-light.svg',
  },
  {
    type: Subject.PHYSICS,
    href: ROUTES.TUTOR_ON_DEMAND_PHYSICS,
    iconSrc: 'mentor-on-demand/icons/physics-black-light.svg',
  },
  {
    type: Subject.BIOLOGY,
    href: ROUTES.TUTOR_ON_DEMAND_BIOLOGY,
    iconSrc: 'mentor-on-demand/icons/biology-black-light.svg',
  },
  {
    type: Subject.OTHER_SUBJECTS,
    href: ROUTES.TUTOR_ON_DEMAND_OTHER_SUBJECTS,
    iconSrc: 'mentor-on-demand/icons/other-subjects-black-light.svg',
  },
]
